module.exports = __webpack_public_path__ + "img/pr-17.5032f316.png";